/* Tice Nits productmotor: vertaling FR/EN, enkel voor wat de klant leest (23 okt 2026).
   Wordt enkel geladen als de taal niet NL is (sections/tn-product.liquid zet window.TN_MOTOR_I18N).
   Woordenboeken (sleutel = de NL-tekst zoals hij in de motor of de cfg staat):
     assets/tn-motor-i18n-<taal>.json               interface van de motor (assets/tn-motor.js)
     assets/tn-motor-i18n-<taal>-<kledingstuk>.json  teksten uit assets/tn-cfg-<kledingstuk>.json
   Een sleutel met {} is een patroon: "Liever ruimer: {}" -> "Plus ample : {}". Wat in {} valt, wordt zelf ook opgezocht.
   Geen vertaling gevonden? Dan blijft de NL-tekst staan. De motor rekent intern altijd met de NL-namen. */
(function () {
  'use strict';
  var C = window.TN_MOTOR_I18N;
  if (!C) return;
  var dict = Object.create(null), pats = [], cache = new Map();
  /* ?tn_i18n=log in de link: ontbrekende vertalingen verzamelen in window.TN_I18N.miss (om het woordenboek aan te vullen) */
  var MISS = /[?&]tn_i18n=log/.test(location.search) ? new Set() : null;
  function norm(s) { return String(s).replace(/\s+/g, ' ').trim(); }
  function esc(x) { return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function add(d) {
    Object.keys(d || {}).forEach(function (k) {
      var v = d[k];
      if (k.charAt(0) === '_' || typeof v !== 'string' || v === '') return;
      var n = norm(k);
      if (n.indexOf('{}') > -1) pats.push([new RegExp('^' + n.split('{}').map(esc).join('(.+?)') + '$'), v]);
      else dict[n] = v;
    });
    // meest specifieke patroon eerst (meeste vaste tekst)
    pats.sort(function (x, y) { return y[0].source.replace(/\(\.\+\?\)/g, '').length - x[0].source.replace(/\(\.\+\?\)/g, '').length; });
    cache.clear();
  }
  function one(k) {
    if (k in dict) return dict[k];
    for (var i = 0; i < pats.length; i++) {
      var m = k.match(pats[i][0]);
      if (!m) continue;
      var j = 1;
      return pats[i][1].replace(/\{\}/g, function () { var g = m[j++] || '', w = list(norm(g)); return w !== null ? w : g; });
    }
    // kleine letter binnen een zin ("zwart draad op wit"): de sleutel met hoofdletter, de vertaling weer klein
    var c0 = k.charAt(0);
    if (c0 !== c0.toUpperCase()) {
      var u = k.charAt(0).toUpperCase() + k.slice(1);
      if (u in dict) { var w = dict[u]; return w.charAt(0).toLowerCase() + w.slice(1); }
    }
    return null;
  }
  /* opsomming ("kies je maat, laad je foto op"): elk deel apart, anders als geheel */
  function list(g) {
    if (g.indexOf(', ') > -1) {
      var parts = g.split(', '), w = parts.map(function (x) { return one(x); });
      if (w.every(function (x) { return x !== null; })) return w.join(', ');
    }
    return one(g);
  }
  /* vertaling of null */
  function tr(s) {
    if (typeof s !== 'string') return null;
    if (cache.has(s)) return cache.get(s);
    var k = norm(s), r = null;
    if (k && /[A-Za-zÀ-ÿ]/.test(k)) {
      r = one(k);
      if (r === null) {
        // samengestelde tekst (bv. de nota onder het voorbeeld): per zin
        var bits = k.replace(/([.!?:])\s+/g, '$1\u0000').split('\u0000'), hit = false;
        if (bits.length > 1) {
          r = bits.map(function (b) { var w = one(b); if (w !== null) hit = true; return w !== null ? w : b; }).join(' ');
          if (!hit) r = null;
        }
      }
      if (r !== null) r = s.match(/^\s*/)[0] + r + s.match(/\s*$/)[0];
    }
    if (r === null && MISS && k && /[A-Za-zÀ-ÿ]{2}/.test(k)) MISS.add(k);
    if (cache.size > 4000) cache.clear();
    cache.set(s, r);
    return r;
  }
  function t(s) { var r = tr(s); return r === null ? s : r; }

  function json(u) { return fetch(u).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }); }
  var got = {}, nl = null, ver = '';
  /* T&A vertaalt optienamen en -waarden ("Maat?" -> "Taille ?", "Wit" -> "Blanc"). De motor zoekt varianten op de
     NL-namen uit de cfg, dus geven we hem de NL-varianten (zelfde id's) via /products/<handle>.js zonder taal in het pad.
     Winkelmand en kassa tonen daarna gewoon de vertaalde variant. */
  function nlVariants(shop) {
    if (nl) return nl;
    if (!C.handle || !shop || !shop.variants) return Promise.resolve();
    nl = fetch('/products/' + encodeURIComponent(C.handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var by = {};
        (p.variants || []).forEach(function (v) { by[v.id] = v.options; });
        shop.variants.forEach(function (v) { if (by[v.id]) v.options = by[v.id]; });
        if (p.options && p.options.length) shop.optionNames = p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
      })
      .catch(function () {});
    return nl;
  }
  function load(garments, shop) {
    var jobs = [nlVariants(shop)];
    if (!got['']) got[''] = json(C.ui).then(function (d) { ver = d._v || ''; add(d); });
    jobs.push(got['']);
    /* de link per kledingstuk heeft een vaste ?v=: de versie uit het interfacebestand erbij, zodat een nieuwe vertaling meteen geladen wordt */
    (garments || []).forEach(function (g) {
      if (!g) return;
      if (!got[g]) got[g] = got[''].then(function () {
        // het eigen kledingstuk heeft een echte link met de juiste ?v=; de andere via het patroon
        return json(C.start && C.start[0] === g ? C.start[1] : C.garment.replace('__ID__', g) + (ver ? '&tv=' + ver : ''));
      }).then(add);
      jobs.push(got[g]);
    });
    return Promise.all(jobs);
  }
  window.TN_I18N = { lang: C.lang, tr: tr, t: t, load: load, add: add, miss: MISS };
})();
